import AppTour from '@components/tour/AppTour';

/**
 * `AppTour` as the finished video results see it, one per area, each with its button in the area it explains: the
 * video (`VIDEO_PLAYER`, in its corner), the count panel (`VIDEO_COUNT_PANEL`, beside its title) and the flight
 * map (`VIDEO_MAP`, in its controls).
 *
 * Mount it only once the results view has rendered: the engine checks once, on mount, whether any step has
 * something to point at, and the loader shown before has nothing. It needs no stages — every step points at
 * something already on the page, and the steps a project lacks (no flight data, one version) are dropped.
 *
 * `round` for the video's corner, where it sits over the picture beside the bigger-video button.
 *
 * `suppressed` while correcting or checking the count: each is a mode with a tour of its own, and a mask over it
 * would trap a half-made fix. `onOpenChange` lets the page hold its shortcuts (Ctrl+Z undoes a fix) while the tour
 * is open.
 */
const ResultsTour = ({ tourId, suppressed = false, onOpenChange, round = false }) => (
	<AppTour tourId={tourId} suppressed={suppressed} onOpenChange={onOpenChange} round={round} />
);

export default ResultsTour;
